import React from 'react';
import { OrderItem, OrderTotals } from '../orderDetailsTypes';
import styles from './OrderItemsTable.module.css';

interface OrderItemsTableProps {
  items: OrderItem[];
  totals: OrderTotals;
}

export const OrderItemsTable: React.FC<OrderItemsTableProps> = ({ items, totals }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Order Items ({items.length})</h3>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>PRODUCT</th>
              <th>CATEGORY</th>
              <th className={styles.numeric}>QTY</th>
              <th className={styles.numeric}>UNIT PRICE</th>
              <th className={styles.numeric}>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>
                  <p className={styles.product}>{item.product}</p>
                  <p className={styles.sku}>{item.sku}</p>
                </td>
                <td>{item.category}</td>
                <td className={styles.numeric}>{item.qty}</td>
                <td className={styles.numeric}>{item.unitPrice}</td>
                <td className={`${styles.numeric} ${styles.bold}`}>{item.total}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={4}>Subtotal</td>
              <td className={`${styles.numeric} ${styles.bold}`}>{totals.subtotal}</td>
            </tr>
            <tr>
              <td colSpan={4}>Estimated Margin (18.5%)</td>
              <td className={`${styles.numeric} ${styles.profit}`}>{totals.estimatedMargin}</td>
            </tr>
            <tr className={styles.totalRow}>
              <td colSpan={4}>Total Amount</td>
              <td className={`${styles.numeric} ${styles.totalAmount}`}>{totals.totalAmount}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
